export default function() {
  return {
    fundings: [],
    allFundings: [],
    funding: {}
  };
}
